import type { ComponentProps, CSSProperties } from 'react'

import styled from 'styled-components'

import { Svg as SvgBase } from '@subaio/components'

export type Props = Partial<Pick<ComponentProps<typeof SvgBase>, 'alt'>> & {
	size?: number
	style?: CSSProperties
}

export const Svg = styled(SvgBase).attrs(({ alt = '' }) => ({
	width: '1em',
	height: '1em',
	alt,
}))<Props>`
	font-size: ${({ size, theme }) => size ?? theme.font.size.icon};
	display: flex;
	justify-content: center;
	align-items: center;
	flex-shrink: 0;
`
